import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class IncomingDataService {
	public incomingDataArray: Array<any>;
	public incomingSQLDataArray: Array<any>;
	public incomingTagsArray: Array<any>;
	public incomingAssetStatusArray: Array<any>;

	constructor() {
		this.incomingDataArray = [];
		this.incomingSQLDataArray = [];
		this.incomingTagsArray = [];
		this.incomingAssetStatusArray = [];
	}
}
